import { client } from "@krea/customer-features/graphql";
import { OperationErrorsFragment } from "@krea/customer-features/graphql/fragments";
import { throwOnOperationErrors } from "@krea/customer-features/graphql/utils";
import { gql, ClientError } from "graphql-request";

export const initiateApplicationViaBankID = async (payload) => {
  const GQL = gql`
    mutation InitiatePendingLoanApplication($input: InitiateApplicationInput!) {
      initiatePendingLoanApplication(input: $input) {
        __typename
        ...OperationErrorsFragment
        ... on InitiateApplicationResponse {
          orderRef
          status
          hintCode
          url
          expiresAt
        }
      }
    }
    ${OperationErrorsFragment}
  `;

  const data = await client.request(GQL, { input: payload });
  throwOnOperationErrors(data);

  return data;
};

export const collectApplicationViaBankID = async (orderRef) => {
  const GQL = gql`
    mutation CollectPendingLoanApplication($input: PendingApplicationInput!) {
      collectPendingLoanApplication(input: $input) {
        __typename
        ...OperationErrorsFragment
        ... on InitiateApplicationResponse {
          orderRef
          status
          hintCode
          url
          expiresAt
          loanApplication {
            id
          }
        }
      }
    }
    ${OperationErrorsFragment}
  `;

  const data = await client.request(GQL, { input: { orderRef } });
  throwOnOperationErrors(data);

  return data;
};

export const cancelApplicationViaBankID = async (orderRef) => {
  const GQL = gql`
    mutation CancelPendingLoanApplication($input: PendingApplicationInput!) {
      cancelPendingLoanApplication(input: $input) {
        __typename
        ...OperationErrorsFragment
        ... on NoContent {
          ok
        }
      }
    }
    ${OperationErrorsFragment}
  `;

  const data = await client.request(GQL, { input: { orderRef } });
  throwOnOperationErrors(data);

  return data;
};
